var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import Actions from '../Card/Actions';
import Button from '../../../Button';
import theme from '../../../Theme/helpers/themeReader';
var _theme$components = theme.components,
    card = _theme$components.card,
    cardweb = _theme$components.cardweb;
var PlanCardButton = styled(Button).attrs({
  full: true
})(_templateObject || (_templateObject = _taggedTemplateLiteralLoose([""])));
var PlanCardButtonText = styled(Button.Text).attrs({
  full: true
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n"])), cardweb.plan.actions.buttonText.margin.top, card.plan.actions.buttonText.margin.bottom);
var PlanCardActions = styled(Actions)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  margin-top: ", "px;\n"])), theme.components.cardweb.plan.actions.margin.top);
PlanCardActions.displayName = 'PlanCard.Actions';
PlanCardButton.displayName = 'PlanCard.Button';
PlanCardButtonText.displayName = 'PlanCard.ButtonText';
export { PlanCardActions as Actions, PlanCardButton as Button, PlanCardButtonText as ButtonText };